import isNumber from 'lodash/isNumber';

import { PreparedWorkload } from 'features/workload-optimization';

import { isWorkloadOptimized } from '../_utils';

export const isCostOptimizedWorkload = (
  workload: PreparedWorkload
): boolean => {
  return (
    isWorkloadOptimized(workload) &&
    isNumber(workload.currentMonthlySavings) &&
    workload.currentMonthlySavings >= 0
  );
};

export const isPerformanceOptimizedWorkload = (
  workload: PreparedWorkload
): boolean => {
  return (
    isWorkloadOptimized(workload) &&
    isNumber(workload.currentMonthlySavings) &&
    workload.currentMonthlySavings < 0
  );
};
